/* eslint-disable global-require */

export default {
  CUSTOMER01: require('./images/removable/customer01.png'),
  CUSTOMER02: require('./images/removable/customer02.png'),
  CUSTOMER03: require('./images/removable/customer03.png'),
  PROFILE_IMAGE: require('./images/removable/profile-image.png'),

  LOGO: require('./images/LOGO.png'),
  DASHBOARD: require('./images/icons/dashboard.svg').default,
  ALERT: require('./images/icons/alert.svg').default,
  PLAYBACK: require('./images/icons/playback.svg').default,
  SPECIALDAY: require('./images/icons/specialday.svg').default,
  SETTINGS: require('./images/icons/settings.svg').default,
  TRAINING: require('./images/icons/training.svg').default,
  PROFILE: require('./images/icons/profile.svg').default,
  LOGOUT: require('./images/icons/logout.svg').default,
  TWOFACTOR: require('./images/icons/twofactor.svg').default,
  COLLAPSE: require('./images/icons/collapse.svg').default,
  MAN: require('./images/icons/man.svg').default,
  PREV: require('./images/icons/prev.svg').default,
  NEXT: require('./images/icons/next.svg').default,
  DROPDOWN: require('./images/icons/dropdown.svg').default, 
  MEETINGS: require('./images/icons/meetings.svg').default,
  CLOSE_WHITE: require('./images/icons/close-white.svg').default,
  EXPAND: require('./images/icons/expand.svg').default,

  HAPPY_BG: require('./images/removable/happy.svg').default,
  SURPRISED_BG: require('./images/removable/surprised.svg').default,
  NEUTRAL_BG: require('./images/removable/neutral.svg').default,
  DISGUSTED_BG: require('./images/removable/disgusted.svg').default,
  CONTEMPT_BG: require('./images/removable/contempt.svg').default,
  CONFUSED_BG: require('./images/removable/confused.svg').default,

  ANIMATED_ROBOT: require('./images/icons/animatedRobot.svg').default,
  AVATAR_MUTE: require('./images/icons/NonSpeaking.svg').default,
  AVATAR_SPEAKING: require('./images/icons/speaking.svg').default,

   ARROW_RIGHT: require('./images/icons/right-arrow.svg').default,
   HEART_BEAT: require('./images/icons/heart-beat.svg').default,
   LUNGS: require('./images/icons/lungs.svg').default,
   STRESS: require('./images/icons/stress.svg').default,

  USERS: require('./images/icons/users.svg').default,
  BOT: require('./images/icons/bot.svg').default,
  PASSWORD: require('./images/icons/password.svg').default,
  CLOCK: require('./images/icons/clock.svg').default,
  NOTIFICATIONS: require('./images/icons/notifications.svg').default,
  CAMERA: require('./images/icons/camera.svg').default,
  EDIT: require('./images/icons/edit.svg').default,
  HAPPY: require('./images/emoji/happy.svg').default,
  SURPRISED: require('./images/emoji/surprised.svg').default,
  CONFUSED: require('./images/emoji/confused.svg').default,
  DISGUSTED: require('./images/emoji/disgusted.svg').default,
  CONTEMPT: require('./images/emoji/contempt.svg').default,

  HAPPY_ACTIVE: require('./images/emoji/happy-colored.svg').default,
  SURPRISED_ACTIVE: require('./images/emoji/surprised-colored.svg').default,
  NEUTRAL_ACTIVE: require('./images/emoji/neutral-colored.svg').default,
  CONFUSED_ACTIVE: require('./images/emoji/confused-colored.svg').default,
  DISGUSTED_ACTIVE: require('./images/emoji/disgusted-colored.svg').default,
  CONTEMPT_ACTIVE: require('./images/emoji/contempt-colored.svg').default,

  CALENDAR: require('./images/icons/calendar.svg').default,

  SEGMENT01: require('./images/segments/segment01.svg').default,
  SEGMENT02: require('./images/segments/segment02.svg').default,
  SEGMENT03: require('./images/segments/segment03.svg').default,
  SEGMENT04: require('./images/segments/segment04.svg').default,
  SEGMENT05: require('./images/segments/segment05.svg').default,
  SEGMENT06: require('./images/segments/segment06.svg').default,

  PYTHON: require('./images/icons/python.svg').default,
  FIGMA: require('./images/icons/figma.svg').default,
  JAVA: require('./images/icons/java.svg').default,
  REACT: require('./images/icons/react.svg').default,
  ANGULAR: require('./images/icons/angular.svg').default,
  PHOTOSHOP: require('./images/icons/photoshop.svg').default,

  TRASH: require('./images/icons/trash.svg').default,
  VIEW: require('./images/icons/eye.svg').default,

  SHOPPING_BAG: require('./images/icons/shoppingbag.svg').default,

  ADD: require('./images/icons/add.svg').default,
  LESS: require('./images/icons/less.svg').default,
  OKO: require('./images/icons/okologo.svg').default,
  OKOLOGO: require('./images/oko-logo.svg').default,

  QUESTIONS: require('./images/icons/questions.svg').default,
  USER: require('./images/icons/user.svg').default,
  INTERVIEW: require('./images/icons/interview.svg').default,
  REPORTS: require('./images/icons/reports.svg').default,
  CLOSE: require('./images/icons/close.svg').default,
  EDITOR: require('./images/icons/editor.svg').default,
  LINK: require('./images/icons/link.svg').default,

  VIDEOCALL: require('./images/removable/videocall.jpg'),
  VIDEOPROFILE: require('./images/removable/profile.jpg'),
  MYPROFILE: require('./images/removable/myprofile.jpg'),
    AI: require('./images/ai.png'),

  SPINNER: require('./images/gif/spinner.gif'),
  BG_ANIMATE: require('./images/gif/background_animation.gif'),
  CROSS: require('./images/icons/cross.svg').default,
  CHECK: require('./images/icons/check.svg').default,
  MENU: require('./images/icons/menu.svg').default,
  HEALTHCARE: require('./images/icons/healthcare.svg').default,
  MEETING: require('./images/icons/meeting.svg').default,
  eKYC: require('./images/icons/eKYC.svg').default,

  USERS_COUNT: require('./images/icons/users-alt.svg').default,
  INTERVIEWS_COUNT: require('./images/icons/interviews.svg').default,
  QUESTIONS_COUNT: require('./images/icons/comments-question.svg').default,
  AVERAGE_SCORES: require('./images/icons/score-board.svg').default,
  CHAT: require('./images/icons/chat.svg').default,
  TRANSCRIPT: require('./images/icons/transcription.svg').default,
};

